import type { IDbConfigResponse } from '../../apis/patent-db-api';

export * from '../../apis/patent-db-api'

export interface PatentDbService {
    /**
     * 获取专利描述
     */
    getDbConfig(): Promise<IDbConfigResponse>;
}

export const PatentDbService = Symbol.for('PatentDbService');
